import { CreditCard, Description, KeyboardArrowDown, Timer } from '@material-ui/icons';
import { Huddle, Payment } from 'lib/generated/graphql';
import moment from 'moment';
import { useRouter } from 'next/router';
import { useState } from 'react';
import PaymentRow from './PaymentRow';

const CustomerPayments = ({ huddle }: { huddle: Huddle }) => {
  const [pastPaymentsOpen, setPastPaymentsOpen] = useState(false);

  const togglePastPayments = () => {
    setPastPaymentsOpen(!pastPaymentsOpen);
  };

  const getAllPayments = () => {
    const payIntervals = huddle.proposal.paySchedule.payIntervals;
    const allPayments: Payment[] = [];
    payIntervals.map((interval, index) => {
      interval.payments.map(payment => {
        allPayments.push(payment);
      });
    });
    return allPayments;
  };

  const getUpcomingStatusHeader = () => {
    const payIntervals = huddle.proposal.paySchedule.payIntervals;
    const allPayments = getAllPayments();
    let upcomingPayment: Payment;

    allPayments.find(item => {
      if (item.paid === false && item.invoiceSent === true) {
        upcomingPayment = item;
      }
    });

    if (upcomingPayment) {
      const startDate = payIntervals.find(interval => interval.id === upcomingPayment.payIntervalId).startDate;
      return `Your next invoice is now Available • Payment due on ${moment(startDate)
        .subtract(5, 'days')
        .format('MMM DD, YYYY')
        .valueOf()}`;
    } else {
      return 'Check back 5 days before your next pay period for your invoice';
    }
  };

  const PayNowButton = ({ huddle }: { huddle: Huddle }) => {
    const router = useRouter();
    const payIntervals = huddle.proposal.paySchedule.payIntervals;
    const allPayments = getAllPayments();
    let upcomingPayment: Payment;

    allPayments.find(item => {
      if (item.paid === false && item.invoiceSent === true) {
        upcomingPayment = item;
      }
    });

    const navigateToPay = (selectedDate: string) => {
      router.push(`/huddles/${huddle?.request?.slug}/proposal/${huddle.proposal.id}/pay?selectedDate=${selectedDate}`);
    };

    const navigateToAgreement = () => {
      router.push(`/huddles/${huddle?.request?.slug}/proposal/${huddle.proposal.id}`);
    };

    return (
      <div>
        {upcomingPayment && payIntervals[upcomingPayment.payIntervalId] !== null && (
          <button
            className="bg-huddleBlack text-white rounded-full border font-xs flex items-center whitespace-nowrap px-3 py-3 gap-2"
            onClick={navigateToPay ? () => navigateToPay(moment(huddle.reservedStartDate).toISOString()) : null}
          >
            <CreditCard />
            <span className="font-xs ">Pay Now</span>
          </button>
        )}{' '}
        {!upcomingPayment && (
          <button
            className="bg-huddleBlack text-white rounded-full border font-xs flex items-center whitespace-nowrap px-3 py-3 gap-2"
            onClick={navigateToAgreement ? () => navigateToAgreement() : null}
          >
            <Description />
            <span className="font-xs ">Agreement</span>
          </button>
        )}
      </div>
    );
  };
  return (
    <>
      <div className="flex flex-row gap-x-5">
        <div onClick={togglePastPayments} className=" grid content-center text-sm font-bold underline cursor-pointer">
          <div className="flex flex-row">
            <div className="grid content-center">
              <div className="whitespace-nowrap text-lg font-medium">Past Payments</div>
            </div>
            <div className="basis-1/3">
              <KeyboardArrowDown
                className={`transform transition-all ease-in-out duration-300 ${
                  pastPaymentsOpen ? 'rotate-180' : 'rotate-0'
                }`}
              />
            </div>
          </div>
        </div>
        <div className="w-full">
          <div className={`text-md bg-[#DEEBE9] rounded-full cursor-default`}>
            <div className="flex flex-auto content-center">
              <div className="grid content-center">
                <div className="bg-[#ABBBB9] rounded-full border font-xs flex items-center whitespace-nowrap px-3 py-3 gap-2">
                  <Timer />
                </div>
              </div>
              <div className="grid content-center ml-5">
                <span className="inline-block content-center text-sm">{getUpcomingStatusHeader()}</span>
              </div>
              {getUpcomingStatusHeader().startsWith('Check') ? null : (
                <div className="ml-auto">
                  <PayNowButton huddle={huddle} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`transform ease-in-out duration-300 ${
          pastPaymentsOpen ? 'max-h-[1000px] opacity-100 visible' : 'max-h-0 opacity-0 invisible'
        }`}
      >
        <div className="w-full justify-between mb-4">
          {getAllPayments().map(payment => (
            <PaymentRow
              key={payment.id}
              huddle={huddle}
              payment={payment}
              intervalStartDate={
                huddle?.proposal?.paySchedule?.payIntervals?.find(interval => interval.id === payment.payIntervalId)
                  ?.startDate
              }
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default CustomerPayments;
